<template>
  <AnnDialog
    :model-value="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
  >
    <div class="ann-share-dialog">
      <img
        class="ann-share-dialog-bg"
        :src="backgroundImg"
        alt=""
        aria-hidden="true"
      />
      <div class="ann-share-dialog-title">{{ t('ann2026.share') }}</div>
      <div class="ann-share-dialog-channels">
        <img
          class="ann-share-dialog-channel btn"
          :src="facebookImg"
          alt="facebook"
          @click="shareToFB"
        />
        <img
          class="ann-share-dialog-channel btn"
          :src="xImg"
          alt="x(twitter)"
          @click="shareToX"
        />
        <img
          class="ann-share-dialog-channel btn"
          :src="whatsappImg"
          alt="whatsapp"
          @click="shareToWhatsApp"
        />
      </div>
      <AnnDialogClose
        :aria-label="t('ann2026.dialog.close')"
        @close="emit('update:modelValue', false)"
      />
    </div>
  </AnnDialog>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import AnnDialog from '../AnnDialog/index.vue'
import AnnDialogClose from '../AnnDialogClose/index.vue'
import backgroundImg from '@/assets/imgs/act/ann2026/popups/power-contributed/background.png'
import facebookImg from '@/assets/imgs/act/mwr/share/facebook.png'
import xImg from '@/assets/imgs/act/mwr/share/x.png'
import whatsappImg from '@/assets/imgs/act/mwr/share/whatsapp.png'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'shareSuccess'])

const { t } = useI18n({ useScope: 'global' })

const sharePageUrl = () => encodeURIComponent(window.location.href)

const afterShare = () => {
  emit('shareSuccess')
  emit('update:modelValue', false)
}

const shareToFB = () => {
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${sharePageUrl()}`,
    '_blank',
  )
  afterShare()
}

const shareToX = () => {
  window.open(
    `https://twitter.com/intent/tweet?url=${sharePageUrl()}`,
    '_blank',
  )
  afterShare()
}

const shareToWhatsApp = () => {
  window.open(`https://wa.me/?text=${sharePageUrl()}`, '_blank')
  afterShare()
}
</script>

<style lang="less" scoped>
.ann-share-dialog {
  --ann-close-top: -12px;
  --ann-close-right: -18px;

  position: relative;
  width: 653px;
  height: 189px;
  overflow: visible;
}

.ann-share-dialog-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 653px;
  height: 203px;
  pointer-events: none;
}

.ann-share-dialog-title {
  position: absolute;
  top: 20px;
  left: 50%;
  z-index: 2;
  margin: 0;
  color: #fff;
  font-size: 32px;
  line-height: 40px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  transform: translateX(-50%);
}

.ann-share-dialog-channels {
  position: absolute;
  top: 90px;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
}

.ann-share-dialog-channel {
  width: 72px;
  height: 72px;
  cursor: pointer;
  object-fit: contain;
}
</style>
